import { is_empty } from "utils/validations";
import { REFERRAL_BANNER_CONSTANTS } from "./ReferralBanner.constants";

export const getInitials = (item) => {
  const { START_INDEX, TWO_PARTS_LENGTH, FALLBACK_INITIAL } =
    REFERRAL_BANNER_CONSTANTS.FRIENDS_CARD;

  const email = item?.referee_email || item?.email || "";
  const name = item?.referee_name || item?.name || "";

  if (!is_empty(name)) {
    const parts = name.trim().split(" ");
    if (parts.length >= TWO_PARTS_LENGTH) {
      return (
        parts[START_INDEX][START_INDEX] + parts[1][START_INDEX]
      ).toUpperCase();
    }
    return name.slice(START_INDEX, TWO_PARTS_LENGTH).toUpperCase();
  }

  if (!is_empty(email)) {
    return email.slice(START_INDEX, TWO_PARTS_LENGTH).toUpperCase();
  }

  return FALLBACK_INITIAL;
};
